export class Deferred<T = void> implements Promise<T> {
  public readonly [Symbol.toStringTag]: 'Deferred';

  private readonly promise: Promise<T>;
  private _resolve: Parameters<ConstructorParameters<typeof Promise<T>>[0]>[0];
  private _reject: Parameters<ConstructorParameters<typeof Promise<T>>[0]>[1];

  public constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  public resolve(...parameters: Parameters<typeof this._resolve>) {
    return this._resolve(...parameters);
  }

  public reject(...parameters: Parameters<typeof this._reject>) {
    return this._reject(...parameters);
  }

  public then<TResult1 = T, TResult2 = never>(
    onfulfilled?: ((value: T) => TResult1 | PromiseLike<TResult1>) | undefined | null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onrejected?: ((reason: any) => TResult2 | PromiseLike<TResult2>) | undefined | null,
  ): Promise<TResult1 | TResult2> {
    return this.promise.then<TResult1, TResult2>(onfulfilled, onrejected);
  }

  public catch<TResult = never>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onrejected?: ((reason: any) => TResult | PromiseLike<TResult>) | undefined | null,
  ): Promise<T | TResult> {
    return this.promise.catch<TResult>(onrejected);
  }

  public finally(onfinally?: (() => void) | undefined | null): Promise<T> {
    return this.promise.finally(onfinally);
  }
}
